const Studentreducer = (state, { type, payload }) => {
    switch (type) {
        case 'setstudent':
            return { ...state, student: payload.student, active_student: payload.active_student };
        case 'setsearch':
            return { ...state, student: payload };
        case 'setactivesearch':
            return { ...state, active_student: payload };
        default:
            return state;
    }
}

export default Studentreducer;